<template>
  <article>
    <fields-group
      label="Блюда"
    >
      <div class="item-table-header mb-4">
        <v-row>
          <v-col md="6">
            <v-text-field
              class="item-table-search"
              v-model="search"
              append-icon="mdi-magnify"
              label="Поиск"
              outlined
              single-line
              hide-details
              clearable
            />
          </v-col>
          <v-col md="6" class="d-flex j-end">
            <v-switch
              class="item-table-switch"
              label="Активные блюда"
              v-model="onlyActiveItems"
              :true-value="1"
              :false-value="0"
              @change="handleOnlyActiveChange"
            />
            <v-switch
              class="item-table-switch"
              label="Только с заданной ценой"
              v-model="onlyWithPriceItems"
              :true-value="1"
              :false-value="0"
              @change="handleOnlyWithPriceItems"
            />
          </v-col>
        </v-row>
      </div>
      <loader v-if="loading"/>
      <v-data-table
        v-else
        :search="search"
        fixed-header
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        class="statistic-datatable headers-nowrap price-list-table"
        :footer-props="{disableItemsPerPage: true}"
        :options="tableOptions"
        :loading="loading"
      >
        <template v-slot:item.name="{ item }">
          <menu-item-label
            :item="item"
            :image-size="75"
            show-edit-link
          />
        </template>
        <template v-slot:item.category="{ item }">
          <menu-item-category :item="item"/>
        </template>
        <template v-slot:item.status="{ item }">
          <span v-if="item.status" class="color-green"><font-awesome-icon icon="check"/></span>
          <span v-else class="color-red"><font-awesome-icon icon="times"/></span>
        </template>
        <template v-slot:item.price="{ item }">
          <v-text-field
            class="mt-5"
            :value="item.price"
            @input="handlePriceInput(item.id, $event)"
            :rules="rules.number"
            background-color="#fff"
            outlined
          />
        </template>
      </v-data-table>
    </fields-group>
  </article>
</template>

<script>
  import rules from '@/mixins/rules'
  import MenuItemLabel from '@/components/stat/menu/MenuItemLabel'
  import MenuItemCategory from '@/components/stat/menu/MenuItemCategory'
  import FieldsGroup from '@/components/ui/FieldsGroup.vue'
  import Loader from '@/components/loader/Loader.vue'

  export default {
    name: 'ItemTable',
    emits: [
      'only-active-changed',
      'only-with-price-changed',
    ],
    mixins: [rules],
    components: {
      Loader,
      FieldsGroup,
      MenuItemCategory,
      MenuItemLabel,
    },
    props: {
      value: Array,
      items: Array,
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        onlyActiveItems: 1,
        onlyWithPriceItems: 0,
        menuItems: [],
        search: '',
        tableOptions: {
          sortBy: ['cost'],
          sortDesc: [true],
        },
        headers: [
          { text: 'ID', value: 'id', align: 'center' },
          { text: 'ID из Юпитера', value: 'externalId', align: 'center' },
          // { text: 'Фото', value: 'image', align: 'right' },
          { text: 'Блюдо', value: 'name', align: 'left', sort: (a, b) => a.toLowerCase().localeCompare(b.toLowerCase()) },
          { text: 'Категория', value: 'category', align: 'left' },
          { text: 'Блюдо активно', value: 'status', align: 'center' },
          { text: 'Базовая цена', value: 'basePrice', align: 'center' },
          { text: 'Цена', value: 'price' },
        ],
      }
    },
    methods: {
      handleOnlyActiveChange () {
        this.$emit('only-active-changed', this.onlyActiveItems)
      },

      handleOnlyWithPriceItems () {
        setInterval(() => {
          this.$emit('only-with-price-changed', this.onlyWithPriceItems)
        }, 300)
      },
      handlePriceInput (itemId, price) {
        const priceListItem = this.value.find(item => item.id === itemId)

        if (priceListItem) {
          const priceListItems = this.value.filter(item => item.id !== priceListItem.id)

          if (Number(price)) {
            priceListItems.push({ id: itemId, price: Number(price) })
          }

          this.$emit('input', priceListItems.slice())
        } else {
          this.$emit('input', [...this.value, { id: itemId, price: Number(price) }])
        }
      },
    },
  }
</script>

<style lang="less" scoped>
@import "src/assets/styles/statistic.less";

.price-list-table {
  &_title {
    font-weight: 500;
    font-size: 2em;
    color: #000;
    margin-bottom: 30px;
  }
}

.item-table {
  &-switch {
    margin-right: 40px;
    &:last-child {
      margin-right: 0;
    }
  }
 /* &-header {
    display: flex;
  }

  &-search {
    margin-right: 40px;
    max-width: 60%;
  }*/
}
</style>
